import '../../styles/index.scss';

import { graphql } from 'gatsby';
import { PropTypes } from 'prop-types';
import React, { useRef } from 'react';

import ArticleEnd from '../../components/Article/ArticleEnd';
import { ArticleHeader } from '../../components/Article/ArticleHeader';
import ArticleInfo from '../../components/Article/ArticleInfo';
import ArticleRecirculation from '../../components/Article/ArticleRecirculation';
import ArticleRender from '../../components/Article/ArticleRender';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Metadata from '../../components/Metadata';
import { checkRequired, getArticleHeaderTheme, toCamelCase } from '../../utils';

const ArticleLongForm = ({ data, location }) => {
  const {
    body,
    credits,
    franchise,
    header,
    heroImage,
    metadata = {},
    publishedDate,
    tags,
    title,
  } = data.contentfulArticleLongForm;

  const hasRequiredFields = checkRequired(body, header);
  if (!hasRequiredFields)
    return <div>Required fields missing in Contentful</div>;

  const headerTheme = getArticleHeaderTheme({
    backgroundColorName: toCamelCase(header?.backgroundColor),
    textColorName: toCamelCase(header?.textColor),
  });

  const breakpointRef = useRef(null);

  const fallbackMetadata = {
    title,
  };

  return (
    <>
      <Metadata
        created={publishedDate}
        data={metadata || fallbackMetadata}
        location={location}
      />
      <div>
        <Header
          backgroundColor={headerTheme.backgroundColor}
          breakpointRef={breakpointRef}
          showBorder
          textColor={headerTheme.textColor}
        />
        <ArticleHeader
          ref={breakpointRef}
          header={header}
          heroImage={heroImage}
        />
        <div
          className="article"
          data-article
          data-module-id="article_long_form_template"
          id="article"
        >
          <ArticleInfo date={publishedDate} pageLocation={location} tags={tags} />
          {body.map((item) =>
            ArticleRender(
              item,
              {
                backgroundColor: header.backgroundColor,
                textColor: header.textColor,
              },
              false,
            ),
          )}
          <ArticleEnd credits={credits} pageLocation={location} tags={tags} />
        </div>
        <ArticleRecirculation
          articleFranchises={franchise}
          articleTags={tags}
          articleTitle={header.title}
          data={data}
        />
      </div>
      <Footer />
    </>
  );
};

ArticleLongForm.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
};

export const query = graphql`
  query ($slug: String, $tags: [String] = [], $franchise: String) {
    contentfulArticleLongForm(slug: { eq: $slug }) {
      
      title
      slug
      tags {
        name
        slug
        type
      }
      franchise {
        franchiseName
      }
      credits {
        name
        slug
        type
      }
      publishedDate
      header {
        title
        headline
        backgroundColor
        textColor
      }
      heroImage {
        title
        image {
          ...ContentfulBaseImageFragment
        }
        wistiaVideoId
      }
      body {
        ... on Node {
          ...ContentfulAllArticleComponentsFragment
        }
      }
      metadata {
        ...ContentfulMetadataFragment
      }
    }
    ...ArticleRecirculationFragment
  }
`;

export default ArticleLongForm;
